import { setCookie, removeCookie, getCookie, expireDateGenerator } from '../../utils/cookies';
import logger from '../../services/logging/logging-service';
import { hideElement, removeAllListeners, unHideElement } from '../../utils/dom-utils';
import { forEach } from '../../utils/array-utils';
import { safeLowerCase, removeTrailingHtmlExtension } from '../../utils/string-utils';
import {
  isHoroscopeAffinity,
  isHoroscopeDetailSignPage,
  HOROSCOPE_COOKIE_NAME,
  isPublishMode,
  goToUrl,
} from '../../utils/aem-utils';
import { trackPageView } from '../../utils/analytics';

const getSelectedSigns = () => {
  const activeSigns = document.querySelectorAll('.c-horoscope-section__grid-container [data-state="active"]');
  return {
    firstSign: safeLowerCase(activeSigns[0].innerText.trim()),
    secondSign: safeLowerCase(activeSigns[1].innerText.trim()),
  };
};

const trackAffinity = (calculateAnother) => {
  const affinityType = calculateAnother ? 'altra-affinita-coppia' : 'affinita-coppia';
  trackPageView(affinityType);
};

const calculateAffinityInsidePage = (calculatorContainer, pairContainer) => {
  const { firstSign, secondSign } = getSelectedSigns();

  const affinityPath = calculatorContainer.dataset.path;
  const urlToCall = `${affinityPath}.${firstSign}.${secondSign}.json`;

  fetch(urlToCall, {
    method: 'GET',
  })
    .then((res) => res.json())
    .then((data) => {
      const responseData = data[0];

      const signsPairTitle = pairContainer.querySelector('.c-section-title');
      const signsPairText = pairContainer.querySelector('.c-affinity-sign-detail__text');
      const signsPairIconPaths = pairContainer.querySelectorAll(
        '.c-affinity-sign-detail__signs .icon--horoscope svg path'
      );

      if (signsPairTitle && signsPairText && signsPairIconPaths.length > 1) {
        signsPairTitle.textContent = `Affinità - ${responseData.sign1.name} ${responseData.sign2.name}`;
        signsPairText.textContent = responseData.text;
        signsPairIconPaths[0].setAttribute('d', responseData.sign1.svgPath);
        signsPairIconPaths[1].setAttribute('d', responseData.sign2.svgPath);

        hideElement(calculatorContainer);
        unHideElement(pairContainer);
      } else {
        throw new Error('One of the elements signsPairTitle, signsPairIconPaths, signsPairText does not exist');
      }
    })
    .catch((err) => {
      logger.error(`Something went wrong. ${err}`);
    });

  trackAffinity();
};

const calculateAffinityInNewPage = () => {
  const { firstSign, secondSign } = getSelectedSigns();
  const currentURL = removeTrailingHtmlExtension(`${window.location.origin}${window.location.pathname}`);
  const signsPairURL = isPublishMode()
    ? `${currentURL}/${firstSign}-${secondSign}`
    : `${currentURL}.${firstSign}.${secondSign}.html`;
  goToUrl(signsPairURL);
};

const enableCalculate = () => {
  const activeHoroscopeSigns = document.querySelectorAll('.j-horoscope-section .icon--horoscope[data-state="active"]');
  const affinityCalculatorContainer = document.querySelector('.j-horoscope-section');
  let affinityCalculate = affinityCalculatorContainer.querySelector('.c-cta');
  affinityCalculate = removeAllListeners(affinityCalculate);

  if (activeHoroscopeSigns.length === 2) {
    if (isHoroscopeAffinity()) {
      affinityCalculate.addEventListener('click', () => {
        calculateAffinityInNewPage();
      });
    } else if (isHoroscopeDetailSignPage()) {
      const signsPairContainer = document.querySelector('.j-affinity-sign-detail');
      let calculateAnother = signsPairContainer.querySelector('.c-cta');
      calculateAnother = removeAllListeners(calculateAnother);

      affinityCalculate.addEventListener('click', () => {
        calculateAffinityInsidePage(affinityCalculatorContainer, signsPairContainer);
      });

      calculateAnother.addEventListener('click', () => {
        unHideElement(affinityCalculatorContainer);
        hideElement(signsPairContainer);
        trackAffinity(true);
      });
    }
    affinityCalculate.classList.remove('is-disabled');
  } else {
    affinityCalculate.classList.add('is-disabled');
  }
};

const setActiveSign = (selectedSign) => {
  const signsContainer = selectedSign.target.closest('.j-horoscope-section .c-horoscope-signs-grid');
  const allSigns = signsContainer.children;

  forEach((singleSign) => {
    if (singleSign.dataset.state && singleSign.dataset.state === 'active') {
      delete singleSign.dataset.state;
    }
  })(allSigns);

  selectedSign.target.closest('.icon--horoscope').dataset.state = 'active';

  enableCalculate();
};

const setClickableSigns = () => {
  const horoscopeSigns = document.querySelectorAll('.j-horoscope-section .icon--horoscope:not([data-state="active"])');

  forEach((sign) =>
    sign.addEventListener('click', (e) => {
      setActiveSign(e);
    })
  )(horoscopeSigns);
};

const getPreferredSign = (sign, button) => {
  const preferredSign = getCookie(HOROSCOPE_COOKIE_NAME);
  if (preferredSign === sign) {
    button.dataset.state = 'active';
  }
};

// TODO: remove in a year (from 26 Gennuary 2021 to 26 Gennuary 2022);
/**
 * function for clean old setted cookies with the wrong path
 */
const clearOldCookie = () => {
  removeCookie(HOROSCOPE_COOKIE_NAME, {
    path: '/',
    insecure: 'insecure',
  });
};

const togglePreferredSign = () => {
  const preferredButton = document.querySelector('.j-toggle-preferred-sign');

  if (preferredButton) {
    const currentSign = preferredButton.dataset.sign;

    getPreferredSign(currentSign, preferredButton);

    preferredButton.addEventListener('click', (e) => {
      const getCTA = e.target.closest('.c-cta');
      const stateActive = getCTA.dataset.state || null;
      const isCookieSet = Boolean(getCookie(HOROSCOPE_COOKIE_NAME));
      const pathEndIndex = window.location.pathname.search(HOROSCOPE_COOKIE_NAME) + HOROSCOPE_COOKIE_NAME.length;
      const cookiePath = window.location.pathname.slice(0, pathEndIndex);

      if (stateActive && isCookieSet) {
        clearOldCookie();
        removeCookie(HOROSCOPE_COOKIE_NAME, {
          path: cookiePath,
          insecure: 'insecure',
        });

        if (!getCookie(HOROSCOPE_COOKIE_NAME)) {
          delete getCTA.dataset.state;
        }
      } else {
        clearOldCookie();
        setCookie(HOROSCOPE_COOKIE_NAME, currentSign, {
          path: cookiePath,
          expires: expireDateGenerator({ days: 365 }),
          insecure: 'insecure',
          samesite: 'strict',
        });

        if (getCookie(HOROSCOPE_COOKIE_NAME)) {
          getCTA.dataset.state = 'active';
        }
      }
    });
  }
};

export const init = () => {
  setClickableSigns();

  if (isHoroscopeDetailSignPage()) {
    togglePreferredSign();
  }
};
